import { useEffect, useRef } from 'react';

import { addRecentlyPlayedGame } from '@/api/recently-played/fetch-recently-played';
import { addTrendingGame } from '@/api/trending-games/add-trending-game';
import { notifyLobbyRefreshRecentlyPlayed } from '@/logic/embedded-availability';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '@/store/useStore';

const useUpdateGameActivity = () => {
  const { gameId, gameUid } = useStore(
    useShallow((s) => ({
      gameId: s.gameContext.gameId,
      gameUid: s.gameContext.gameUid,
    })),
  );

  const hasActiveSession = useStore(
    useShallow((s) => s.userSessionContext.hasActiveSession),
  );
  const lastGameIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!hasActiveSession) return;

    const resolvedGameId = gameId || gameUid;

    if (!resolvedGameId || lastGameIdRef.current === resolvedGameId) {
      return;
    }

    lastGameIdRef.current = resolvedGameId;

    Promise.resolve(addRecentlyPlayedGame({ gameId: resolvedGameId }))
      .then(notifyLobbyRefreshRecentlyPlayed)
      .catch(() => null);
    Promise.resolve(addTrendingGame({ gameId: resolvedGameId })).catch(
      () => null,
    );
  }, [gameId, gameUid, hasActiveSession]);
};

export default useUpdateGameActivity;
